
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"48.72","width":"52.56","height":"8.49","rx":"4.25","fill":"#e8eae9"}}),_c('path',{attrs:{"d":"M97 7.48H53a4.23 4.23 0 01-4.19-3.74 4.2 4.2 0 00-.05.51A4.24 4.24 0 0053 8.49h44a4.24 4.24 0 004.24-4.24 4.2 4.2 0 000-.51A4.23 4.23 0 0197 7.48z","fill":"#d1d3d4"}}),_c('path',{attrs:{"d":"M54.61 8.49h40.78v136.57a4.94 4.94 0 01-4.94 4.94h-30.9a4.94 4.94 0 01-4.94-4.94V8.49z","fill":"#e8eae9"}}),_c('path',{attrs:{"d":"M86.71 147.35H63.29a5.27 5.27 0 01-5.29-5.27V31a2.15 2.15 0 012.15-2.15h.3c9.6 3.51 17.71 3.88 29.36 0a1.85 1.85 0 012.19 1.9v111.33a5.27 5.27 0 01-5.29 5.27z","fill":"#3cc7f4"}}),_c('path',{attrs:{"fill":"none","stroke":"#414042","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.087","d":"M75.15 11.32v135.24M75.15 130.39h12.13M62.72 117.96h12.13M75.15 105.73h12.13M62.72 93.3h12.13M75.15 81.06h12.13M62.72 68.63h12.13M75.15 56.4h12.13M62.72 43.97h12.13M75.15 31.74h12.13M62.72 19.31h12.13M75.15 138.07h6.07M68.78 124.17h6.07M75.15 112.58h6.07M68.78 98.68h6.07M75.15 87.08h6.07M68.78 73.18h6.07M75.15 63.25h6.07M68.78 49.35h6.07M75.15 38.69h6.07M68.78 24.79h6.07"}})])
          )
        }
      }
    